import { Component, OnInit, ViewContainerRef  } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Meta, Title, BrowserModule } from '@angular/platform-browser';
import { appService, IMessage } from './app.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'kts-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    providers: [appService] 
})

export class ContactUsComponent implements OnInit {

    submitted = false;
    doneLoadingMap: boolean = false;
    message: IMessage = {};
    constructor(public toastr: ToastsManager, vcr: ViewContainerRef, meta: Meta, title: Title, private _appService: appService) {
        this.toastr.setRootViewContainerRef(vcr);
        title.setTitle('Contact Us | Katiso Engineering and Automation');

        meta.updateTag({
                name: 'keywords', content: 'Katiso Engineering, Automotive Supplier, contact, email, questions, Gauteng, Pretoria, East London, PLC, robot, production, design, manufacturing, automation'
            })
        meta.updateTag({
                name: 'description', content: 'Katiso South Africa\'s head office is situated in the heart of the high veld. Gauteng, Pretoria. Our East London office provides PLC & Robot production support to local manufacturers. | Katiso Engineering and Automation'
            })
    }

    showError() {
        this.toastr.error('Something went wrong, please try again', 'Oops!');
    }

    showSuccess() {
        this.toastr.success('Thank you for contacting us, we will get back to you as soon as possible', 'Success!');
    }
    sendEmail(message: IMessage) {
        this._appService.sendEmail(message).subscribe(res => {
            this.showSuccess();
            console.log('AppComponent Success', res);
        }, error => {
            console.log('AppComponent Error', error);
            this.showError();
        })
  }

    ngOnInit() {
    }
    onSubmit() {
        this.submitted = true;
    }
    isValid() {
    return this.message.name === ''
        || RegExp(/\d/gmi).test(this.message.name)
        || !RegExp(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/gmi).test(this.message.email)
        || this.message.message === ''
        || !RegExp(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/gmi).test(this.message.phone)
  }

   
}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/contact-us/contact-us.component.ts